import * as React from 'react'

const styling: React.CSSProperties = {   
    border: '1px solid transparent',
    fontSize: '35px',
    cursor: 'pointer',
    width: '25px',
    height: '25px',
    textAlign: 'center',
    color: 'darkgray',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    zIndex: 98,
}

type Props = {
    closeAction: () => void,
    top?: string;
    right?: string;
    position?:string;
}

 export class CampusCloseX extends React.Component<Props, any>{
    render() {
        var offset = {
            top: this.props.top || styling.top,
            right: this.props.right || styling.right,
            position: this.props.position || styling.position
        }
        var finalStyling = Object.assign({}, styling, offset);

        return (
            <div style={finalStyling} onClick={this.props.closeAction}>&times;</div>
        );
    }
}

